// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2han9","errorLogs":"EditorFooter_errorLogs__ZIdhQ"};